import { type PayloadAction, createReducer } from '@reduxjs/toolkit';
import {
    cancelImageGeneration,
    changeImageGenerationLoaderText,
    generateImageAnimationEnd,
    generateImageAnimationStart,
    generateImageStart,
    incrementImageGenerationPercentage,
    resetImageGeneration,
    setAiPhotoGenerationCommented,
    setAiPhotoGenerationRated,
    setAiPhotoGenerationSaved,
    setGenerationPhotoScreenState,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { aiPhotoGenerationLoaderTextVariants } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.constants';
import { getAiPhotoGenerationRandomVariantExcluding } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.helpers';
import { aiPhotoGenerationImageHelper } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.image';
import {
    type IAiGenerateImageRequest,
    type IAiGenerationState,
    type IGenerateImageEnd,
    type IResetGenerationImage,
    type ISetGenerationPhotoScreenState,
    EAiPhotoGenerationState,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

const initialState: IAiGenerationState = {
    generation: {
        state: EAiPhotoGenerationState.idle,
    },
};

export const aiPhotoGenerationReducer = createReducer(initialState, {
    [generateImageStart.type]: (state, action: PayloadAction<IAiGenerateImageRequest>) => {
        state.generation = {
            state: EAiPhotoGenerationState.proccess,
            percentage: 1,
            textVariant: aiPhotoGenerationLoaderTextVariants.variant1,
            startTime: performance.now(),
        };
        state.prompt = action.payload.prompt;
        state.style = action.payload.style;
    },
    [generateImageAnimationStart.type]: (state, action: PayloadAction<IGenerateImageEnd>) => {
        const { image, size, time } = action.payload;

        state.generation = {
            ...state.generation,
            state: EAiPhotoGenerationState.endAnimation,
            image,
            size,
            time,
        };
    },
    [generateImageAnimationEnd.type]: (state) => {
        state.generation.state = EAiPhotoGenerationState.complete;
    },
    [resetImageGeneration.type]: (state, action: PayloadAction<IResetGenerationImage>) => {
        const { savePrompt } = action.payload;

        aiPhotoGenerationImageHelper.resetImageData();
        state.generation = {
            state: EAiPhotoGenerationState.idle,
        };

        if (!savePrompt) {
            state.prompt = '';
            state.style = null;
        }
    },
    [cancelImageGeneration.type]: (state) => {
        state.generation = {
            state: EAiPhotoGenerationState.idle,
        };
    },
    [incrementImageGenerationPercentage.type]: (state) => {
        if (state.generation.percentage && state.generation.percentage < 99) {
            state.generation.percentage += 1;
        }
    },
    [changeImageGenerationLoaderText.type]: (state) => {
        state.generation.textVariant = getAiPhotoGenerationRandomVariantExcluding(state.generation.textVariant);
    },
    [setGenerationPhotoScreenState.type]: (state, action: PayloadAction<ISetGenerationPhotoScreenState>) => {
        const { state: newState } = action.payload;

        state.generation.state = newState;
    },
    [setAiPhotoGenerationSaved.type]: (state) => {
        state.generation.saved = true;
    },
    [setAiPhotoGenerationRated.type]: (state) => {
        state.generation.rated = true;
    },
    [setAiPhotoGenerationCommented.type]: (state) => {
        state.generation.commented = true;
    },
});
